function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 50,
    style: {
      fill: "#F2F2F2"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M67.1,44c-0.9,0.3-2.1,0.5-3.8,0.6c0.1-3.6,1-6.7,2.8-9.3c1.8-2.6,4.8-4.4,9-5.3   c0,0.1,0.1,0.2,0.1,0.4c0,0.2,0.1,0.3,0.1,0.4s0,0.2,0,0.4c0,0.1,0,0.3,0,0.4c0,1.5-0.3,3.1-1,4.9c-0.7,1.8-1.8,3.5-3.3,5   C69.7,42.7,68.4,43.6,67.1,44z M83.3,69.3c-1.7-2.4-2.5-5.1-2.5-8c0-2.7,0.8-5.2,2.3-7.5c0.8-1.2,2.2-2.6,4.1-4.3   c-1.3-1.5-2.5-2.7-3.8-3.6c-2.3-1.6-4.8-2.3-7.7-2.3c-1.7,0-3.8,0.4-6.2,1.2c-2.4,0.8-4.1,1.2-5.2,1.2c-0.8,0-2.5-0.4-5-1.1   c-2.5-0.7-4.7-1.1-6.4-1.1c-4.1,0-7.5,1.7-10.2,5.2s-4.1,8-4.1,13.5c0,5.8,1.8,11.9,5.3,18.1c3.6,6.2,7.2,9.3,10.9,9.3   c1.2,0,2.8-0.4,4.8-1.2c1.9-0.8,3.7-1.2,5.1-1.2c1.6,0,3.4,0.4,5.4,1.2c2.2,0.8,3.9,1.2,5,1.2c3.1,0,6.2-2.4,9.3-7.1   c2-3,3.5-6,4.4-9C86.9,73.2,85,71.6,83.3,69.3z",
    style: {
      fill: "#231F20"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.bbdf0ac38195e93d6c9d8d9aa50550bc.svg";
export { ForwardRef as ReactComponent };